import React from 'react'

const CartLoader = () => {
  return (
    <div className='cartLoaderWrapper'>
        <div className="cartLoader"></div>
    </div>
  )
}

export default CartLoader
